import { DOCUMENT } from '@angular/common';
import { Component, Input, Inject, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { College, HighSchool, Team, User } from '@athlete-x/definitions';
import { IS_MOBILE } from '@athlete-x/shared';
import { DirectoryService } from '@athlete-x/features/directory';

@Component({
    selector: 'atx-sidebar-teams-list',
    templateUrl: 'sidebar-teams-list.component.html',
    styleUrls: ['sidebar-teams-list.component.scss']
})
export class SidebarTeamsListComponent {
    @Input() user!: User;
    @Input() currentTeam!: Team;
    @Input() isGlobal!: boolean;

    @Output() navigateToGlobal = new EventEmitter<boolean>();
    @Output() changeGlobalAccessSettings = new EventEmitter<boolean>();
    @Output() changeRoute = new EventEmitter<{ route: string, slug: string }>();

    public get currentSchool () {
        return this.currentTeam.college || this.currentTeam.high_school;
    }

    public isMobile = this._isMobile;

    public globalSchoolId$ = this._directory.globalSchoolId$;

    constructor(
        @Inject(DOCUMENT) private _document: Document,
        @Inject(IS_MOBILE) private _isMobile: boolean,
        private _router: Router,
        private _directory: DirectoryService
    ) {

    }

    public onTeamClicked(team?: Team) {
         if (team) {
            const slug = team.slug;
            const currentTeamSlug = this.currentTeam.slug;

            if (team.status !== 'active' && slug === currentTeamSlug) {
                return;
            }

            if (slug === currentTeamSlug) {
                this._router.navigate(['/']);
            } else {
                this._navigateAndRefresh(slug);
            }
        } else {
            this._openSchoolGlobal();
            // this._openGlobal();
        }
    }

    public openSchoolGLobal(school: College | HighSchool) {
        if (this.user.global) {
            this._router.navigate(['school', school.id]);

        } else {
            this.changeGlobalAccessSettings.emit();
        }
    }

    private _openGlobal() {
        const active = this.user.teams.reduce((acc, team) => {
            return acc || team.status === 'active';
        }, false);

        if (!active) {
            alert('In order to access Global, you must be an approved member of at least one team network.');
        } else {
            this.navigateToGlobal.emit(true);
        }
    }

    private _openSchoolGlobal() {
        const school = this.currentSchool;
        this._router.navigate(['school', school.id]);
    }

    public changeUserDirectoryType(event: any) {
        event.stopPropagation();
        event.preventDefault();

        this.changeGlobalAccessSettings.emit();
    }

    private _navigateAndRefresh(slug: string) {
        const redirect = this._document?.baseURI + slug;
        this._document.location.href = redirect;
    }

    public navigateToTeamsListEdit(event: any) {
        event.stopPropagation();
        event.preventDefault();
        this.changeRoute
            .emit({ route: 'teams-list', slug: '' });
    }

    public navigateToWaitList(event: any, teamSlug: string) {
        event.stopPropagation();
        event.preventDefault();
        const currentTeamSlug = this.currentTeam.slug;

        if (currentTeamSlug === teamSlug) {
            this.changeRoute
                .emit({ route: 'waitlist', slug: '' });
        } else {
            this.changeRoute
                .emit({ route: 'waitlist', slug: teamSlug });
        }

    }

    trackByTeamId(index: number, team: Team): number {
        return team.id;
    }

    public onGroupClicked(group: any) {
        const { meta, ...school } = group.parent;

        this._router.navigate(['school', school.id]);
    }


}
